export enum LinkedConversationsDataEventObject {
  P3_PILL = 'linked_conversations_p3_pill',
  CREATE_LINKED_CONVERSATION = 'create_linked_conversation',
  CREATE_LINKED_DISCUSSION = 'create_linked_discussion',
  CREATE_LINKED_TASK = 'create_linked_task',
  UNLINK_CONVERSATION = 'unlink_conversation',
  VIEW_ALL = 'linked_conversation_view_all',
  VIEW_ALL_TASKS = 'linked_conversation_view_all_tasks',
  ACCESS_MODAL = 'linked_conversation_access_modal',
  VIEW_LINKED_CONVERSATION = 'view_linked_conversation',
  SEARCH_ORIGINAL_CONVERSATION = 'search_original_conversation',
  BULK_LINK_CONVERSATION = 'bulk_link_conversation',
}
